import axiosInstance from './axiosInstance';

const getRequestConfig = (payload) => (
  payload instanceof FormData
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : undefined
);

export const eventsAPI = {
  getEvents: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    const url = query ? `/events/?${query}` : '/events/';
    const response = await axiosInstance.get(url);
    return response.data;
  },

  createEvent: async (payload) => {
    const response = await axiosInstance.post('/events/', payload, getRequestConfig(payload));
    return response.data;
  },

  updateEvent: async (eventId, payload) => {
    const response = await axiosInstance.patch(`/events/${eventId}/`, payload, getRequestConfig(payload));
    return response.data;
  },

  deleteEvent: async (eventId) => {
    const response = await axiosInstance.delete(`/events/${eventId}/`);
    return response.data;
  },

  subscribeEvent: async (eventId) => {
    const response = await axiosInstance.post(`/events/${eventId}/subscribe/`);
    return response.data;
  },

  unsubscribeEvent: async (eventId) => {
    const response = await axiosInstance.post(`/events/${eventId}/unsubscribe/`);
    return response.data;
  },

  getEventFeedback: async (eventId) => {
    const response = await axiosInstance.get(`/events/${eventId}/feedback/`);
    return response.data;
  },

  submitEventFeedback: async (eventId, payload) => {
    const response = await axiosInstance.post(`/events/${eventId}/feedback/`, payload);
    return response.data;
  },

  getMyEventFeedbacks: async () => {
    const response = await axiosInstance.get('/event-feedbacks/mine/');
    return response.data;
  },

  getAdminEventFeedbacks: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    const url = query ? `/event-feedbacks/admin/?${query}` : '/event-feedbacks/admin/';
    const response = await axiosInstance.get(url);
    return response.data;
  },

  approveEventFeedback: async (feedbackId, admin_comment = '') => {
    const response = await axiosInstance.post(`/event-feedbacks/${feedbackId}/approve/`, { admin_comment });
    return response.data;
  },

  rejectEventFeedback: async (feedbackId, admin_comment = '') => {
    const response = await axiosInstance.post(`/event-feedbacks/${feedbackId}/reject/`, { admin_comment });
    return response.data;
  },
};
